import { css, styled, typography } from '@pulse-web-ui/theme';

export const Label = styled.div`
  ${typography.regular14};
  white-space: pre-wrap;
  color: ${({ theme }) => theme.colors.text.secondary};

  @media (min-width: 768px) {
    min-width: 216px;
  }
`;

export const Value = styled.div<{ $isHightlight?: boolean }>`
  ${typography.regular16};
  color: ${({ theme, $isHightlight }) =>
    $isHightlight ? theme.colors.text.warning : theme.colors.text.primary};
`;

export const LabelValueList = styled.div<{ $isWithDesktopStyles?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${({ $isWithDesktopStyles }) =>
    $isWithDesktopStyles &&
    css`
      @media (min-width: 768px) {
        flex-direction: row;
        align-items: baseline;
        gap: 12px;
      }
    `}
`;
